
function Directive (){
    return {
        restrict: 'E',
        template: require('./detailHeader.jade')
    };
}

export default Directive;


// WEBPACK FOOTER //
// ./app/common/widgets/detailHeader.js